// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
// eslint-disable-next-line no-restricted-imports
import {jsx} from 'panel';
import type {VNode} from 'snabbdom';
import type {JsxVNodeChildren} from 'snabbdom-jsx-lite';

import {HORIZONTAL_CONTENT_PADDING_STYLE} from 'common/report/layout/banner-layout/index';
import {ReportMessageBannerEl} from 'common/widgets/report-message-banner';
import {ReportBannersEl} from 'common/widgets/report-banners';
import {isTestEnv} from 'common/report/util/env';
import {ReportLayoutManager} from 'common/report/contexts/report-layout';

/**
 * @deprecated
 * This is a legacy version of BannerLayout that's used by reports that haven't been converted to React.
 * New reports should use the React version of BannerLayout.
 */
export function ContentFrame(
  {
    sel,
    contentFrameClass,
    minContentWidth,
    maxContentWidth,
    isCoreReport,
    reportLayoutManager,
  }: {
    sel?: string;
    contentFrameClass?: Record<string, boolean>;
    minContentWidth?: number;
    maxContentWidth?: number;
    isCoreReport?: boolean;
    reportLayoutManager?: ReportLayoutManager;
  },
  block: JsxVNodeChildren,
): VNode {
  return (
    <div
      sel={sel}
      class={{
        ...contentFrameClass,
        'content-frame': true,
        'inherit-size': true,
      }}
    >
      <div
        sel='.width-frame'
        class={{
          'inherit-size': true,
        }}
        style={{
          margin: isCoreReport ? null : `0 auto`,
          'max-width': maxContentWidth ? `${maxContentWidth}px` : undefined,
          'min-width': minContentWidth ? `${minContentWidth}px` : undefined,
        }}
      >
        <div
          sel='.padding-frame'
          class={{
            'inherit-size': true,
            'scroll-container': true,
          }}
          style={{
            'box-sizing': `border-box`,
            'overflow-y': `auto`,
            padding: isCoreReport
              ? `32px 0 0 0`
              : `0 ${HORIZONTAL_CONTENT_PADDING_STYLE} 6vh ${HORIZONTAL_CONTENT_PADDING_STYLE}`,
          }}
          hook={{
            insert: (vnode: VNode) => {
              reportLayoutManager?.updateScrollContainer(vnode.elm as HTMLElement);
            },
          }}
        >
          {!isTestEnv() && !isCoreReport && (
            <div sel='.banner-container' style={{'margin-top': `20px`}}>
              <ReportMessageBannerEl />
              <ReportBannersEl />
            </div>
          )}
          {block}
        </div>
      </div>
    </div>
  );
}
